import { useEffect } from "react";
import { Outlet } from "react-router";
import { useAuth } from "@saas/ui";

export function TaskShell() {
  const { me } = useAuth();
  useEffect(() => {
    const previous = document.title;
    document.title = `Tasuki | ${me?.tenant.name ?? "ooak"}`;
    return () => {
      document.title = previous;
    };
  }, [me?.tenant.name]);
  return (
    <div className="tasuki tk-shell">
      <a href="#task-main" className="tk-skip">
        タスク本文へ移動
      </a>
      <main id="task-main" tabIndex={-1} className="tk-main">
        <Outlet />
      </main>
    </div>
  );
}
